import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Store from './store';
import Footer from './components/footer';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();


const styles = require('./index.less');

/**
 * @param {string} position: sticky | fixed
 */
function BackTopFooter({ store, className, position = 'sticky' }) {
  store.use();

  const renderButton = btn => {
    if (!store.btns.includes(btn)) {
      return null;
    }

    switch (btn) {
      case 'backTop':
        return (
          <div className={styles.btnBackTop} onClick={store.backTop}>
            <div className={styles.icon} style={{ backgroundImage: `url(${store.backTopIcon})` }} />
          </div>
        );
      case 'scrollDownTip':
        return (
          <div className={styles.scrollDown}>
            <div className={styles.scrollDownIcon} style={{ backgroundImage: `url(${store.scrollDownIcon})` }} />
          </div>
        );
      case 'copyright':
        return (
          <div
            className={styles.btnCopyright}
            onClick={store.toggleCRFooterVisible}
            style={{ color: store.copyrightColor, backgroundImage: `url(${store.copyrightBorder})` }}
          >
            {pageLocalesData.copyrightInformation}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className={cx(styles.footerRoot, styles[position], { [styles.isActive]: store.isActive })}>
      <section className={cx(styles.footer, className)}>
        <div className={styles.before} style={{ backgroundImage: `url(${store.beforeBg})` }} />
        <div className={styles.after} style={{ backgroundImage: `url(${store.afterBg})` }} />
        <div className={cx(styles.footerInner, { [styles.showBtnBackTop]: store.isShowBackTop })}>
          {renderButton('scrollDownTip')}
          {renderButton('backTop')}
          {renderButton('copyright')}
        </div>
        {/* 使用sticky，父元素不能设置 overflow: hidden; */}
        {position === 'sticky' && <style>{'#pc-layout-main { overflow: visible }'}</style>}
      </section>
      {store.btns.includes('copyright') && (
        <div className={styles.copyRightFooter}>
          <Footer store={store.footerStore} />
        </div>
      )}
    </div>
  );
}

export default wrapStore(BackTopFooter, Store);
